import { TaskCreate } from 'app/agriculture/routes/Tasks/TaskCreate/TaskCreate';
import { TaskDelete } from 'app/agriculture/routes/Tasks/TaskDelete/TaskDelete';
import { TaskDetails } from 'app/agriculture/routes/Tasks/TaskDetails/TaskDetails';
import { TaskEdit } from 'app/agriculture/routes/Tasks/TaskEdit/TaskEdit';
import { TaskList } from 'app/agriculture/routes/Tasks/TaskList/TaskList';
import { RouteConfig } from 'app/agriculture/router/types';

export const tasksRouteConfig: RouteConfig = {
    rootPath: 'tasks',
    routeElements: {
        Create: { Component: TaskCreate },
        Delete: { Component: TaskDelete },
        Details: { Component: TaskDetails },
        Edit: { Component: TaskEdit },
        List: { Component: TaskList },
    },
};
